// extracted by mini-css-extract-plugin
module.exports = {"root":"ServicablePopup_root__S4QIO","text":"ServicablePopup_text__Pnwud"};